import React, {PropsWithChildren} from "react";
import {Container} from "react-bootstrap";
import {StyledSpinner} from "../styles";

interface LoaderProps {
    loading: boolean;
}

export function SpinnerLoader(props: PropsWithChildren<LoaderProps>): JSX.Element {
    return (
        <>
            {props.loading && (
                <Container className="text-center text-sm-center">
                    <StyledSpinner className="fa fa-spinner fa-spin" />
                </Container>
            )}
        </>
    );
}